import {Action} from '@ngrx/store';


export const PAGE_STATE_RESET = '[AufgabePage] Page State reset';
export const SETZE_VERANSTALTUNG_ID = '[AufgabePage] Setze Veranstaltung Id';
export const SETZE_CHECKLISTE_ID = '[AufgabePage] Setze Checkliste Id';
export const SETZE_FUNKTIONSBEREICH_ID = '[AufgabePage] Setze Funktionsbereich Id';
export const SETZE_AUFGABE_ID = '[AufgabePage] Setze Aufgabe Id';
export const AUFGABE_NICHT_OK_GEMELDET = '[AufgabePage] Aufagbe nicht Ok gemeldet';
export const IGNORE_WS_ACTION = '[AufgabePage] WS Action ignoriert';

// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// IGNORE WS ACTION
export class IgnoreWSAction implements Action {
    readonly type = IGNORE_WS_ACTION;

    constructor(public payload: any) {
    }
}

export class SetzeVeranstaltungIdAction implements Action {
    readonly type = SETZE_VERANSTALTUNG_ID;

    constructor(public veranstaltungId: string) {
    }
}

export class SetzeFunktionsbereichIdAction implements Action {
    readonly type = SETZE_FUNKTIONSBEREICH_ID;

    constructor(public funktionsbereichId: string) {
    }
}

export class SetzeChecklisteIdAction implements Action {
    readonly type = SETZE_CHECKLISTE_ID;

    constructor(public checklisteId: string) {
    }
}

export class SetzeAufgabeIdAction implements Action {
    readonly type = SETZE_AUFGABE_ID;

    constructor(public aufgabeId: string) {
    }
}

export class AufgabeNichtOkGemeldetAction implements Action {
    readonly type = AUFGABE_NICHT_OK_GEMELDET;

    constructor() {
    }
}


/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    AufgabeNichtOkGemeldetAction
    | PageStateResetAction
    | IgnoreWSAction
    | SetzeFunktionsbereichIdAction
    | SetzeChecklisteIdAction
    | SetzeAufgabeIdAction
    | SetzeVeranstaltungIdAction
    ;
